    const $ = require('jquery');
    (function () {
        $('#btnRight').click(function (e) {
            var selectedOpts = $('#lstBox1 option:selected');
            if (selectedOpts.length == 0) {
                alert("Nothing to move.");
                e.preventDefault();
            }
            $('#lstBox2').append($(selectedOpts).clone());
            $('#lstBox2').change();
            $(selectedOpts).remove();
            e.preventDefault();
        });
        $('#btnLeft').click(function (e) {
            var selectedOpts = $('#lstBox2 option:selected');
            if (selectedOpts.length == 0) {
                alert("Nothing to move.");
                e.preventDefault();
            }
            $('#lstBox1').append($(selectedOpts).clone());
            $(selectedOpts).remove();
            $('#lstBox2').change();
            e.preventDefault();
        });
        $('#lstBox2').change( function() {
            var ids = '';
            $("#lstBox2 option").each(function() {
                ids += $(this).val()+',';
            });
            $('#counties_selected').val(ids);

        });
        
        $('#state').change( function (e) {
            var select = e.target;
            var state_id = $(select).val();
            var prot = location.protocol;

            if (state_id) {
                axios.get("/api/counties/"+state_id).then((response) => {
                    const data = response.data;
                    countySelected = $('#county').val();
                    if ( "" == countySelected && typeof county_id != "undefined")  {
                        countySelected = county_id;
                    }
                    $('#county').empty();
                    $('#county')
                          .append($('<option>', {  text: "Choose County", value: ''}));
                    $.each(data, function(key, value) {
                       if ( countySelected == value.id ) {
                        $('#county')
                          .append($('<option>', { value : value.id, text: value.name, selected: "selected" }));
                       } else {
                            $('#county')
                          .append($('<option>', { value : value.id, text: value.name }));
                       }
                    });
                    var prevSelected = [];
                    $("#lstBox2 option").each(function() {
                        prevSelected.push( $(this).val());
                    });
                    $('#lstBox1').children().remove();
                    $('#lstBox1')
                          .append($('<option>', { value : 'all' }).text('All'));
                    $.each(data, function(key, value) {
                       if( prevSelected.indexOf( value.id.toString() ) == -1) {
                            $('#lstBox1')
                              .append($('<option>', { value : value.id })
                              .text(value.name));
                        }
                    });
                });
            }
        });

        $('#org_type').change ( function (e) {
            var orgtype = e.target;
            var selected = $(orgtype).val();
            if ( selected == 12 ) {
                // other, please specify
                $('#org_type_other').prop("disabled", false);
            } else {
                $('#org_type_other').prop("disabled", true);
            }
        });
    }($));
    $().ready( function() {
        $('#state').change();
        $('#org_type').change();
    });

